import React, { useState, useEffect } from "react";
import axios from "axios";
import { Loader2, Inbox, Clock, CheckCircle2, Archive, ShieldAlert, Images } from "lucide-react";
import { API, STATUS, fmtDate } from "./shared";

const CARDS = [
  { key: "active_requests", label: "Aktívne požiadavky", icon: Inbox, cls: "text-blue-300" },
  { key: "in_progress", label: "V riešení", icon: Clock, cls: "text-amber-300" },
  { key: "completed_this_month", label: "Dokončené tento mesiac", icon: CheckCircle2, cls: "text-green-300" },
  { key: "archived", label: "Archivované", icon: Archive, cls: "text-white/60" },
  { key: "security_events_30d", label: "Bezpečnostné udalosti (30 dní)", icon: ShieldAlert, cls: "text-red-300" },
  { key: "gallery_count", label: "Fotky v galérii", icon: Images, cls: "text-brand" },
];

export default function Dashboard({ token }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/dashboard`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setData(data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="py-20 text-center text-white/50" data-testid="dashboard-loading"><Loader2 className="w-6 h-6 animate-spin mx-auto" /></div>;

  return (
    <div data-testid="dashboard-panel">
      <h1 className="font-head text-2xl font-semibold mb-1">Dashboard</h1>
      <p className="text-white/60 text-sm mb-8">Prehľad aktivity a stavu systému.</p>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
        {CARDS.map(({ key, label, icon: Icon, cls }) => (
          <div key={key} data-testid={`stat-${key}`} className="bg-white/5 border border-white/10 rounded-xl p-5">
            <div className="flex items-center justify-between mb-3">
              <span className="text-white/60 text-sm">{label}</span>
              <Icon className={`w-5 h-5 ${cls}`} />
            </div>
            <p className="font-head text-3xl font-bold">{data ? data[key] : 0}</p>
          </div>
        ))}
      </div>

      <h2 className="font-head text-lg font-semibold mb-4">Posledných 5 požiadaviek</h2>
      {!data || data.recent.length === 0 ? (
        <div className="border border-dashed border-white/15 rounded-xl py-12 text-center text-white/50">Zatiaľ žiadne požiadavky.</div>
      ) : (
        <div className="rounded-xl border border-white/10 divide-y divide-white/5" data-testid="dashboard-recent">
          {data.recent.map((r) => {
            const s = STATUS[r.status] || STATUS.new;
            return (
              <div key={r.id} className="flex items-center justify-between gap-4 px-4 py-3">
                <div className="min-w-0">
                  <p className="font-mono text-brand text-sm">{r.request_number}</p>
                  <p className="text-white/80 truncate">{r.name} · <span className="text-white/50">{r.service_type}</span></p>
                </div>
                <div className="text-right shrink-0">
                  <span className={`inline-block text-xs font-medium px-2.5 py-1 rounded-full border ${s.cls}`}>{s.label}</span>
                  <p className="text-white/40 text-xs mt-1">{fmtDate(r.created_at)}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
